import { type ICustomImage } from "@filmweb/sanity-types";
import type { PortableTextBlock, Reference, SanityDocument, Slug } from "sanity";
import type IFilmklipp from "src/lib/types/Filmklipp";
import { type IFilmomtale } from "src/lib/types/Filmomtale";
import { type ITrailer } from "src/lib/types/Trailer";

import type IAuthor from "src/lib/types/Author";
import type IGallery from "src/lib/types/IGallery";


const DocType_Filmnytt = "filmnytt";

export { DocType_Filmnytt };

type ValidTags = "Feature" | "Guide" | "Interview" | "Nyhed" | "Podcast" | "Quiz" | "Sponsoreret" | "Streaming" | "Tema" | "Trailer" | "Video";

export default interface IFilmnytt extends SanityDocument, ICompetition {
    _type: "filmnytt";
    title: string;
    sectionPageTitle?: string;
    isStreaming: boolean;
    streamingBoxPosition?: "inline" | "top"
    slug: Slug;
    summary_v2?: PortableTextBlock[];
    ingress?: PortableTextBlock[];
    bodytext?: PortableTextBlock[];
    source?: string;
    author?: Reference | IAuthor;
    topGallery?: (Reference | IFilmomtale | IGallery);
    imageV2?: ICustomImage[];

    sectionPageImageV2?: ICustomImage;
    related?: (Reference | ITrailer | IFilmnytt | IFilmomtale | IFilmklipp)[];
    eceId?: number;
    eceSrc?: string;
    eceSrcId?: string;
    firstPublishedAt?: string;
    createdAt?: string;
    updatedAt?: string;
    hideAds?: boolean;
    isAdContent?: boolean;
    wufooFormUrl?: string;
    eceLastUpdated?: string;
    extLink?: string;
    ntbId?: string;
    imageTextTopImage?: string;
    tags?: ValidTags | null;


}

export interface ICompetition {
    competitionTitle?: string | null;
    competitionQuestion?: string | null;
    competitionOptions?: string[] | null;
    competitionShowFieldPhone?: boolean | null;
}

export function isFilmnytt(document: SanityDocument): document is IFilmnytt {
    return document._type === DocType_Filmnytt;
}